const GOOGLE_CLIENT_ID_REGEX = /[0-9]+\.[0-9]+$/g

/**
 * The Google Client ID stored in the _ga cookie has a prefix that needs to be removed before sending
 * it to Marketo. For example, the if the cookie contains "GA.1.2546404655.1631045250", we should
 * pass the sanitized ID "2546404655.1631045250" to Marketo.
 */
export default function sanitizeGoogleClientId(id: string): string {
  const match = id.match(GOOGLE_CLIENT_ID_REGEX) ?? ['']
  return match[0]
}
